import * as React from "react";
import {
    Field,
    FieldWrapper,
    FormRenderProps,
  } from "@progress/kendo-react-form";
import { DropDownListField } from "./FormComponents";
import { DropDownListCustomHandle } from "./DropDownlistCustom";
import { DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { requiredValidator } from "../utils/validators";


interface WindowLabelingChildLabelProps { 
    Id: string;  
    Name: string; 
    LabelApiUrl: string;
    KeyField: string;
    TextField: string;
    Label: string;  
    EntityValue:number;
    ParentLabelId?:number; 
    onChange: (event: DropDownListChangeEvent) => void; 
    onReset: (event: Event, renderProps: FormRenderProps) => void;
    Value: any;
    required?: boolean;
}

export const WindowLabelingChildLabel = (props: WindowLabelingChildLabelProps) => {

    const forwardRefChildLabel= React.useRef<DropDownListCustomHandle>(null)

    React.useEffect(() => {
        if(props.Value){
            forwardRefChildLabel.current?.settingValue(props.Value);
        }
        if(props.ParentLabelId){
          forwardRefChildLabel.current?.openDropDown?.();

          forwardRefChildLabel.current?.setValueFilter( {
              logic: "and",
              filters: [                
                {
                  field: "ParentId",
                  operator: "eq",
                  value: props.ParentLabelId
                }
              ]
            });
        }
        
    },[]);

    return (
        <FieldWrapper key={props.Id}>
                  <Field
                    id={props.Id}
                    name={props.Name}
                    component={DropDownListField}
                    keyField={"LabelId"}
                    textField={"LabelDescription"}
                    odataApiUrl={props.LabelApiUrl}
                    label={props.Label}
                    forwardRef={forwardRefChildLabel}  
                    onChange={props.onChange}   
                    validator={props.required === false ? undefined : requiredValidator}
                    handleResetValue={props.onReset} 
                    value={props.Value}               
                  />
        </FieldWrapper>
    );

}

